"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedCurrencyError = void 0;
const getSymbolAndNetwork = (symbolWithNetwork) => {
    if (typeof symbolWithNetwork === 'string') {
        const [symbol, network] = symbolWithNetwork.split('-');
        return { symbol, network };
    }
    const { value: symbol, network } = symbolWithNetwork;
    return { symbol, network };
};
class UnsupportedCurrencyError extends Error {
    constructor(symbolWithNetwork) {
        const { symbol, network } = getSymbolAndNetwork(symbolWithNetwork);
        super(`The currency '${symbol}'${network ? ` on ${network}` : ''} is unknown or not supported.`);
        this.symbol = symbol;
        this.network = network;
    }
}
exports.UnsupportedCurrencyError = UnsupportedCurrencyError;
